import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabViewComponent } from './tab-view/tab-view.component';
import { TabPanelComponent } from './tab-panel/tab-panel.component';

@NgModule({
    declarations: [TabViewComponent, TabPanelComponent],
    imports: [CommonModule],
    exports: [TabViewComponent, TabPanelComponent]
})
export class TabViewCustomModule {}